import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { ModalService } from '@usheru-hff/shared/utils-modal';

@Injectable({ providedIn: 'root' })
export class MovieSiteEditorService {
  private router = inject(Router);
  private modalService = inject(ModalService);

  public isEnabled = signal(false);

  async open(): Promise<void> {
    const { MovieSiteEditorComponent } = await import(
      /* webpackChunkName: "movie-site-editor" */ '@usheru-hff/core/movie-site/editor'
    );

    this.modalService.openModal(MovieSiteEditorComponent, {
      id: 'movie-site-editor_modal',
      params: {
        header: 'Movie Editor',
        width: '80vw',
        modal: true,
        dismissableMask: true,
        closable: true,
        styleClass: 'movie-editor-modal'
      },
      allowScroll: true
    });
  }
}
